import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

export default function YieldMeter() {
  const [count, setCount] = useState(0);
  const target = 1000;

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const increment = target / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, []);

  const percentage = Math.min((count / target) * 100, 100);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6 }}
      className="bg-zinc-900/50 border border-amber-500/30 rounded-lg p-6 box-glow-amber"
    >
      <div className="text-[10px] font-mono tracking-widest text-amber-400 uppercase mb-2">
        Target Floor // Per Sovereign Node
      </div>
      <div className="flex items-baseline gap-1 mb-4">
        <span className="text-4xl md:text-5xl font-black text-amber-400 text-glow-amber font-mono">
          ${count.toLocaleString()}
        </span>
        <span className="text-sm text-zinc-500 font-mono">/month</span>
      </div>

      {/* Progress Bar */}
      <div className="h-2 bg-zinc-950 rounded-full overflow-hidden border border-zinc-800 mb-3">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 2, ease: 'easeOut' }}
          className="h-full bg-gradient-to-r from-amber-500 to-amber-400 relative"
        >
          <div className="absolute inset-0 bg-white/20 animate-pulse" />
        </motion.div>
      </div>

      <div className="flex items-center justify-between text-[10px] font-mono text-zinc-600">
        <span>$0</span>
        <span className="text-emerald-400">FLOOR REACHED ✓</span>
        <span>${target.toLocaleString()}</span>
      </div>

      <div className="mt-4 pt-4 border-t border-zinc-800/50">
        <p className="text-[11px] text-zinc-500 leading-relaxed">
          <span className="text-zinc-300 font-bold">Non-speculative.</span> Backed by enterprise data acquisition contracts. 
          Real fiat settlement. No token volatility. No crypto casino.
        </p>
      </div>
    </motion.div>
  );
}